module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-97.9fdd108c.svg";